var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "504.000000pt",
    height: "548.000000pt",
    viewBox: "0 0 504.000000 548.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,548.000000) scale(0.100000,-0.100000)",
    fill: "#ceb081",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2405 5189 c-28 -3 -70 -16 -95 -29 -46 -24 -1920 -1137 -1981 -1177 -57 -37 -82 -92 -77 -168 3 -48 10 -70 30 -97 20 -26 287 -193 1025 -639 548 -332 1020 -611 1048 -621 58 -20 128 -23 190 -7 67 17 2051 1217 2090 1264 24 29 30 47 33 100 6 85 -20 131 -102 184 -139 89 -1923 1145 -1970 1166 -58 26 -119 34 -191 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 2992 c-177 -105 -272 -168 -289 -191 -20 -26 -27 -48 -30 -97 -4 -55 -1 -69 22 -108 25 -43 76 -75 1037 -651 555 -334 1030 -613 1055 -622 63 -21 174 -14 234 17 25 12 487 288 1027 612 691 414 990 598 1007 621 51 66 51 167 1 233 -15 20 -121 89 -288 188 -145 86 -268 156 -274 156 -5 0 -336 -197 -734 -437 -398 -240 -745 -445 -772 -455 -58 -22 -150 -23 -212 -3 -36 13 -590 344 -1403 838 -51 32 -98 57 -105 57 -7 0 -131 -71 -276 -158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 1874 c-331 -198 -316 -188 -340 -235 -31 -59 -25 -152 12 -200 18 -25 293 -195 998 -619 535 -322 1002 -600 1039 -617 56 -28 77 -33 138 -33 46 0 90 7 120 18 59 23 1997 1185 2036 1221 52 47 71 106 55 173 -17 76 -45 99 -321 264 -144 86 -267 157 -273 157 -5 0 -341 -198 -745 -440 -404 -242 -749 -445 -768 -452 -52 -17 -164 -14 -218 7 -39 15 -398 230 -1433 859 -30 18 -59 33 -65 32 -5 0 -111 -61 -235 -135z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.7ac0069f7b4a62a257fd17c1a220c629.svg";
export { ForwardRef as ReactComponent };